<template>
  <div v-if="show" class="timeline-volume-slider" @mouseover="mouseover" @mouseleave="mouseleave">
    <i></i>
    <div class="v-slider-rc" @mousewheel="mousewheel">
      <div class="v-slider-rail"></div>
      <div class="v-slider-track" :style="{'height': volumeSize + '%'}"></div>
      <div class="v-slider-click" @click="changeByclick"></div>
      <div v-volumeHandle class="v-slider-handle" :style="{'bottom': volumeSize + '%'}"></div>
    </div>
    <div class="volume-size">{{volumeSize}}</div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: 'VolumeSlider',
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false
    },
    volumeType: {
      type: String,
      required: true,
      default: ''
    }
  },
  data() {
    return {
      volumeSize: 100,
      oldVolume: -1,
      inside: false
    }
  },
  computed: {
    ...mapGetters({
      dubbingVolume: "addSoundtrack/getDubbingVolume",
      musicVolume: "addSoundtrack/getMusicVolume"
    }),
  },
  mounted() {
    if(this.volumeType) {
      this.volumeSize = this[`${this.volumeType}Volume`];
    }
    this.$bus.on("subtitle_undoRodo_execute", ({mod, type}) => {
      if(mod === "changeVolume" && this.volumeType) {
        this.volumeSize = this[`${this.volumeType}Volume`];
      }
    })
  },
  beforeDestroy() {
    this.$bus.$off("subtitle_undoRodo_execute");
  },
  methods: {
    changeVolume() {
      this.$store.commit("addSoundtrack/changeVolume", {
        type: this.volumeType,
        volume: this.volumeSize
      });
    },
    changeByclick(e) {
      let volume = (70 - e.layerY) / 70 * 100;
      this.setVolumeSize(volume);
    },
    mousewheel(e) {
      e.preventDefault();
      let volume = this.volumeSize + e.deltaY;
      this.setVolumeSize(volume);
    },
    setVolumeSize(volume){
      this.volumeSize = Math.round(volume < 0 ? 0 : volume > 100 ? 100 : volume);
      this.changeVolume();
    },
    mouseover() {
      if(this.oldVolume < 0) {
        this.volumeSize = this[`${this.volumeType}Volume`];
        this.oldVolume = this.volumeSize;
      }
    },
    mouseleave() {
      if(this.oldVolume !== this.volumeSize) {
        this.$bus.emit("insert_subtitle_undo", {
          type: "changeVolume",
          data: {
            volumeType: this.volumeType,
            data: this.volumeSize,
            reData: this.oldVolume
          }
        })
      }
      this.oldVolume = -1;
    }
  },
  directives: {
    volumeHandle(el, binding, vnode) {
      let _this = vnode.context,
        volumeSize = 0,
        mousemove = null,
        mouseup = null,
        disy = 0;

      mousemove = e => {
        if(_this.oldVolume < 0) {
          document.removeEventListener("mousemove", mousemove);
          document.removeEventListener("mouseup", mouseup);
          return;
        }
        var pre = ((e.pageY - disy) / 70) * 100;
        _this.setVolumeSize(volumeSize - pre);
      };

      mouseup = e => {
        document.removeEventListener("mousemove", mousemove);
        document.removeEventListener("mouseup", mouseup);
      };

      el.onmousedown = e => {
        e.preventDefault();
        e.stopPropagation();

        volumeSize = _this.volumeSize;
        disy = e.pageY;

        document.addEventListener("mousemove", mousemove);
        document.addEventListener("mouseup", mouseup);
      };
    },
  }
}
</script>
<style lang="scss" scoped>
.timeline-volume-slider {
  position: absolute;
  bottom: 0px;
  left: 0px;
  width: 31px;
  height: 24px;
  border-radius: 8px;
  overflow: hidden;
  // transition: all .1s;

  &:hover {
    height: 118px;
    background-color: #ECECEC;

    .v-slider-rc {
      display: block;
    }

    .volume-size {
      display: block;
    }
  }

  .volume-size {
    display: none;
    margin-top: 5px;
    font-size: 12px;
    color: #606266;
  }

  i {
    position: absolute;
    bottom: 7px;
    left: 9px;
    width: 12px;
    height: 10px;
    background: url("../../../static/svg/volume.svg") no-repeat center;
  }

  * {
    box-sizing: border-box;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  .v-slider-rc {
    transition: all .1s;
    display: none;
    position: absolute;
    bottom: 24px;
    height: 70px;
    width: 100%;
    padding: 0 14px;
    touch-action: none;
  }

  .v-slider-rail {
    position: absolute;
    width: 2px;
    height: 100%;
    background: #fff;
    border-radius: 2px;
  }

  .v-slider-track {
    position: absolute;
    bottom: 0;
    background-color: #5778fb;
    width: 2px;
    border-radius: 2px;
  }

  .v-slider-click{
    position: absolute;
    left: 14px;
    bottom: 0;
    width: 2px;
    height: 100%;
    background-color: transparent;
    cursor: pointer;
  }

  .v-slider-handle {
    position: absolute;
    margin-left: -3px;
    margin-bottom: -3px;
    width: 8px;
    height: 8px;
    background-color: #5778fb;
    border: 0;
    border-radius: 50%;
    cursor: -webkit-grab;
    cursor: grab;
    touch-action: pan-x;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/timelineContent/volume.vue